import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=f5e6367a&scoped=true"
import script from "./purchase.vue?vue&type=script&lang=ts"
export * from "./purchase.vue?vue&type=script&lang=ts"
import style0 from "./purchase.vue?vue&type=style&index=0&id=f5e6367a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e6367a",
  null
  
)

export default component.exports